<mat-toolbar class="footer">
    <div class="colored" [style.background-color]="theme.getColor('Main Light')"></div>
    <span class="content">www.sogeti.com</span>
</mat-toolbar>
